/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Complete_ToastInputs */

const en_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle export finished successfully`)
};

const fr_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'exportation des sous-titres s'est terminée avec succès.`)
};

const de_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Export der Untertitel wurde erfolgreich abgeschlossen.`)
};

const it_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione dei sottotitoli completata con successo`)
};

const ru_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт субтитров успешно завершен.`)
};

const es_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La exportación de subtítulos finalizó correctamente`)
};

const zh_cn2_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导出已成功完成`)
};

const ja_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のエクスポートが正常に完了しました`)
};

const hi_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_subtitle_export_complete_toast = /** @type {(inputs: Subtitle_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de legendas concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Subtitle export finished successfully" |
*
* @param {Subtitle_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_complete_toast = /** @type {((inputs?: Subtitle_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_complete_toast(inputs)
	if (locale === "de") return de_subtitle_export_complete_toast(inputs)
	if (locale === "it") return it_subtitle_export_complete_toast(inputs)
	if (locale === "ru") return ru_subtitle_export_complete_toast(inputs)
	if (locale === "es") return es_subtitle_export_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_complete_toast(inputs)
	if (locale === "ja") return ja_subtitle_export_complete_toast(inputs)
	if (locale === "hi") return hi_subtitle_export_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_complete_toast(inputs)
	return en_subtitle_export_complete_toast(inputs)
});